module.exports = __webpack_public_path__ + "static/media/Street.15f59d61.svg";